import { MenuItem, PopoverOrigin, SxProps, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import { Fragment } from 'react';

import { CustomPopover } from '@components/CustomPopover';
import Divider from '@components/Divider';
import { v4 } from 'uuid';

import { ActionsConfigItem } from './types';

export interface MoreMenuPopoverProps {
  open: boolean;
  handleClose: (e: React.MouseEvent<HTMLElement>) => void;
  sx?: SxProps;
  actions: ActionsConfigItem[];
  anchorOrigin?: PopoverOrigin | undefined;
  disabledArrow?: boolean;
  anchorEl: HTMLElement | null;
}

export const MoreMenuPopover = ({ open, anchorEl, handleClose, actions }: MoreMenuPopoverProps) => {
  return (
    <CustomPopover
      open={open}
      onClose={handleClose}
      slotProps={{ arrow: { placement: 'top-right' } }}
      anchorEl={anchorEl}
    >
      {actions.map((action) => {
        if (action.hide) return null;

        return (
          <Fragment key={v4()}>
            {action.primary && <Divider sx={{ my: 0.5 }} dashed />}
            <Tooltip title={action.tooltip || ''} placement="bottom">
              <Box component="span">
                <MenuItem
                  disabled={action.disabled}
                  sx={action.sx}
                  onClick={(e) => {
                    action.onClick();
                    handleClose(e);
                  }}
                >
                  {action.icon || null}
                  {action.title}
                </MenuItem>
              </Box>
            </Tooltip>
          </Fragment>
        );
      })}
    </CustomPopover>
  );
};
